export default {
	/**
	 * 保存token
	 */
	saveToken({commit, state}, token) {
		localStorage.token = token;
		commit('token', token);
	},

	/**
	 * 获取token,没有token 就去授权获取
	 * 顺序 1、state; 2、localStorage；3、url
	 */
	getToken({commit, state, dispatch}) {
		var token = '';
		var search = location.search.substring(1);
		var searchArr = search.split('&');
		var searchObj = {};
		if(searchArr.length !== 0) {
			searchArr.map(item => {
				const itemArr = item.split('=');
				searchObj[itemArr[0]] = decodeURI(itemArr[1]);
			});
		}
		if(localStorage.token||searchObj.token){
            dispatch('saveToken', localStorage.token||searchObj.token);
			return {token: localStorage.token||searchObj.token};
		}else{
			// wxAuthBase();
		}

	},
}



// WEBPACK FOOTER //
// ./src/store/actions.js